import React from 'react';
import Card from '@/components/ui/Card';
import { SeasonOverview } from '@/types';

interface SeasonOverviewCardsProps {
  overview: SeasonOverview;
}

const SeasonOverviewCards: React.FC<SeasonOverviewCardsProps> = ({ overview }) => {
  const cards = [
    { label: 'Played', value: overview.totalMatches, color: 'text-gray-900 dark:text-gray-100' },
    { label: 'W-D-L', value: `${overview.wins}-${overview.draws}-${overview.losses}`, color: 'text-gray-900 dark:text-gray-100' },
    { label: 'Points', value: overview.points, color: 'text-blue-600 dark:text-blue-400' },
    { label: 'GF / GA', value: `${overview.goalsFor} / ${overview.goalsAgainst}`, color: 'text-gray-900 dark:text-gray-100' },
    { label: 'Goal Diff', value: overview.goalDiff > 0 ? `+${overview.goalDiff}` : String(overview.goalDiff), color: (() => { if (overview.goalDiff > 0) return 'text-green-600 dark:text-green-400'; if (overview.goalDiff < 0) return 'text-red-600 dark:text-red-400'; return 'text-gray-900 dark:text-gray-100'; })() },
    { label: 'Clean Sheets', value: overview.cleanSheets, color: 'text-purple-600 dark:text-purple-400' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
      {cards.map((card) => (
        <Card key={card.label} padding="sm">
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">{card.label}</p>
          <p className={`text-2xl font-bold mt-1 ${card.color}`}>{card.value}</p>
        </Card>
      ))}
    </div>
  );
};

export default SeasonOverviewCards;
